import React from "react"
import { CaseStudyCtaWrapper } from "./CaseStudyCta.styles"
import ArrowRight from "../../../icons/phosphor/regular/ArrowRight"

export default function(){
  return (
      <CaseStudyCtaWrapper className="px-3">
        <div className="container">
          <h2>The APEXX Payment Orchestration Platform is the last integration you will ever need.</h2>
          <div className="buttons">
            <a href="/contact-us" className="btn">Contact our sales team</a>
            <a href="/payment-orchestration-platform/" className="btn ghost">
              See how it works
              <ArrowRight />
            </a>
          </div>
        </div>
      </CaseStudyCtaWrapper>
  )
}